export const POLICY_QUERY_PREFIX = 'open-enrollment' as const
export const POLICY_QUERY_KEYS = {
  all: [POLICY_QUERY_PREFIX, 'oep-policy'] as const,
  // The default period keeps the pre-EMS-10557 key, so every existing reader and
  // `[..., companyId]` prefix invalidation still covers it; a selected period is one level deeper.
  detail: (companyId: string, oepId?: string) =>
    oepId
      ? ([POLICY_QUERY_PREFIX, 'oep-policy', companyId, oepId] as const)
      : ([POLICY_QUERY_PREFIX, 'oep-policy', companyId] as const),
} as const
